module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("This book is dedicated to my own amazing unit: my wife, Tara, and our three troopers, Sam, Jude, and Liberty. It is also for all the dads who kept asking, “Have you written that book yet? I really need a copy.”")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements"
  }, [_vm._v("Thank you all.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23768659","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03dedication.vue
// module id = 63
// module chunks = 0